"use client";
import React from "react";
import Link from "next/link";

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <div
      className="w-full pt-[84px] relative z-40"
      style={{
        background: "rgba(7,11,20,0.85)",
        backdropFilter: "blur(12px)",
        borderBottom: "1px solid rgba(255,255,255,0.06)",
      }}
    >
      <div className="max-w-container mx-auto px-4 sm:px-6">
        <nav
          aria-label="Breadcrumb"
          className="flex items-center gap-1.5 pt-4 pb-2.5 overflow-x-auto"
          style={{ scrollbarWidth: "none", WebkitOverflowScrolling: "touch" } as React.CSSProperties}
        >
          {items.map((item, index) => {
            const isLast = index === items.length - 1;
            return (
              <React.Fragment key={index}>
                {index > 0 && (
                  <span
                    className="text-[13px] select-none flex-shrink-0"
                    style={{ color: "#475569" }}
                    aria-hidden="true"
                  >
                    ›
                  </span>
                )}
                {isLast || !item.href ? (
                  <span
                    className="text-[13px] font-body font-medium whitespace-nowrap flex-shrink-0"
                    style={{ color: isLast ? "#F8FAFC" : "#9CA3AF" }}
                    aria-current={isLast ? "page" : undefined}
                  >
                    {item.label}
                  </span>
                ) : (
                  <Link
                    href={item.href}
                    className="text-[13px] font-body font-medium whitespace-nowrap flex-shrink-0 transition-colors duration-200 hover:text-white"
                    style={{ color: "#9CA3AF" }}
                  >
                    {item.label}
                  </Link>
                )}
              </React.Fragment>
            );
          })}
        </nav>
      </div>
    </div>
  );
}
